import Q9 from './Q9';

export default Q9;
